import { CustomerInfoProviderInterface } from "@lib/CustomerInfoProvider/CustomerInfoProviderInterface";
import { InjectionKey } from "@lib/svelte-typed-context";
import { URLsBuilder } from "@modules/common_module/URLsBuilder/URLsBuilder";
import { GwI18n } from "@modules/i18n/GwI18n/GwI18n";

export const urlsBuilderContextToken = Symbol(
    "urlsBuilderContextToken"
) as InjectionKey<URLsBuilder>;

export const gwI18nContextToken = Symbol(
    "gw18nContextToken"
) as InjectionKey<GwI18n>;

export const customerInfoProviderContextToken = Symbol(
    "customerInfoProviderContextToken"
) as InjectionKey<CustomerInfoProviderInterface>;
